import produce from 'immer';
import { useStagedState } from 'common/hooks/useStagedState';
import { MetricEntry, MetricEntryBehavior } from 'common/query-builder/query-entry-section/types';
import type { RowProps } from '../types/catalog';

/**
 * Hook to manage a list of behaviors for a MetricEntry.
 * @todo(metrics) tracking
 */
export function useBehaviorsList(entry: MetricEntry, onUpdate: RowProps[`updateEntry`]) {
  var _entry$behavior$behav;
  const [behaviors, setBehaviors] = useStagedState((_entry$behavior$behav = entry.behavior.behaviors) !== null && _entry$behavior$behav !== void 0 ? _entry$behavior$behav : [], state => {
    onUpdate(produce(entry, draft => {
      draft.behavior.behaviors = state;
    }));
  });
  const handleAddBehavior = (newBehavior: MetricEntryBehavior) => {
    setBehaviors([...behaviors, newBehavior], true);
  };
  const handleUpdateBehavior = (index: number, updatedBehavior: MetricEntryBehavior) => {
    setBehaviors(produce(behaviors, draft => {
      draft[index] = updatedBehavior;
    }), true);
  };
  const handleDeleteBehavior = (index: number) => {
    setBehaviors(produce(behaviors, draft => {
      draft.splice(index, 1);
    }), true);
  };
  const handleDuplicateBehavior = (index: number) => {
    setBehaviors(produce(behaviors, draft => {
      const behavior = draft[index];
      draft.splice(index + 1, 0, behavior);
    }), true);
  };
  return {
    behaviors,
    handleAddBehavior,
    handleUpdateBehavior,
    handleDeleteBehavior,
    handleDuplicateBehavior
  };
}